export default __webpack_public_path__ + "static/media/Pistol_1.b1862619.png";